import React, { FC } from 'react';
import { SectionBreadcrumbs } from '../../common/SectionBreadcrumbs';
import { CLASSIFIER_ROUTES } from './Classifiers';
import { ClassifierBreadcrumbsProps } from './ClassifierBreadcrumbs.types';

export const ClassifierBreadcrumbs: FC<ClassifierBreadcrumbsProps> = (
  props
) => <SectionBreadcrumbs {...props} routes={CLASSIFIER_ROUTES} />;
